import { useEffect } from "react";
import { applyHead, type PageHead } from "../seo";

/**
 * Applies a page's head after a client-side navigation.
 *
 * It renders nothing. The head is written by mutating the document rather than
 * by returning elements, for one reason: this component also runs inside the
 * build-time render that produces the prerendered documents, and a head emitted
 * as markup there would land in the body and be duplicated beside the real one.
 * The build script serialises the same `PageHead` into `<head>` itself.
 *
 * A crawler is therefore served the head in the HTML, and a reader who arrives
 * on one page and clicks through to another gets the same head applied by the
 * effect. Neither path owns a second copy of a title.
 */
export function Seo({ head }: { head: PageHead }) {
  useEffect(() => {
    applyHead(head, document);
  }, [head]);

  return null;
}
